import React from 'react';

const LogoutModalContext = React.createContext(null);

export default LogoutModalContext;
